<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="month" label="Bulan">
                    <model-select
                      id="month"
                      :options="listMonth"
                      v-model="currentMonth"
                      placeholder="Bulan"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="year" label="Tahun">
                    <model-select
                      id="year"
                      :options="listYear"
                      v-model="currentYear"
                      placeholder="Tahun"
                    ></model-select>
                  </b-form-group>
                </b-col>

              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="getListingAttendance"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <div slot="header">
            <div class="float-left">Absensi Karyawan</div>
          </div>
          <b-card-body>
            <b-row>
              <b-col lg="12">
               
               <div class="table-responsive">
                  <table v-if="!loading" class="table table-bordered table-striped table-responsive font-size-10">
                      <thead>
                        <tr>
                          <td rowspan="2" style="tex-align: center; vertical-align: middle;">NIK</td>
                          <td rowspan="2" style="tex-align: center; vertical-align: middle;">NAME</td>
                          <td class="blue-col" style="tex-align: center; vertical-align: middle;" :colspan="listSourceCompanySalary.length">Source Salary</td>
                          <td class="red-col" style="tex-align: center; vertical-align: middle;" :colspan="listSourceCompanySalary.length">Deduction</td>
                          <td class="green-col" style="tex-align: center; vertical-align: middle;" :colspan="listSourceCompanySalary.length">Paid</td>
                          <td class="yellow-col" style="tex-align: center; vertical-align: middle;" :colspan="listDeduction.length">Status</td>

                          <!-- <td rowspan="2">TOTAL GAJI PER BULAN</td>
                          <td rowspan="2">TOTAL POTONGAN</td>
                          <td rowspan="2">GAJI BULAN INI</td> -->

                        </tr>

                        <tr>
                            <!-- Source Salary List -->
                           <template v-for="(v, key) in listSourceCompanySalary" >
                            <td class="blue-col" :key="uniqueId('employee'+key)">{{v.name}}</td>
                           </template>
                         
                            <!-- Source Status -->
                           <template v-for="(vDeduc, keyDeduc) in listSourceCompanySalary" >
                            <td class="red-col" :key="uniqueId('employee'+keyDeduc)">{{vDeduc.name}}</td>
                           </template>

                           <template v-for="(vDeduc2, keyDeduc2) in listSourceCompanySalary" >
                            <td class="green-col" :key="uniqueId('employee'+keyDeduc2)">{{vDeduc2.name}}</td>
                           </template>

                           <template v-for="(valStatus, keyStatus) in listDeduction" >
                            <td class="yellow-col" :key="uniqueId('employee'+keyStatus)">{{valStatus.code}}</td>
                           </template>
                        </tr>
                      </thead>
                    

                      <tbody v-if="listData">
                        <template v-for="(data, nik) in listData" >
                          <tr :key="uniqueId('employee'+nik)">
                              <td><b>{{nik}}</b></td>
                              <td>{{data.name}}</td>
                              
                               <!-- Source Status -->
                              <template v-for="(v2, key2) in listSourceCompanySalary" >
                                <td class="blue-col" :key="uniqueId('employee'+key2)">{{formatPrice(data.source_salary[v2.name])}}</td>
                              </template>

                               <!-- Deduction -->
                              <template v-for="(vDeduc2, keyDeduc2) in listSourceCompanySalary" >
                                <td class="red-col" :key="uniqueId('employee'+keyDeduc2)">{{ (data.source_salary[vDeduc2.name] !== 0) ? formatPrice(Math.round(data.deduction / data.total_source_salary)): 0 }}</td>
                              </template>

                               <!-- paid -->
                              <template v-for="(vDeduc3, keyDeduc3) in listSourceCompanySalary" >
                                <td class="green-col" :key="uniqueId('employee'+keyDeduc3)">{{ (data.source_salary[vDeduc3.name] !== 0) ? formatPrice((data.source_salary[vDeduc3.name] - Math.round(data.deduction / data.total_source_salary))): 0 }}</td>
                              </template>


                              <template v-for="(valStatus, keyStatus) in listDeduction" >
                                <td class="yellow-col" :key="uniqueId('employee'+keyStatus)">{{data.calculation[valStatus.code]}}</td>
                              </template>

                              <!-- <td>{{formatPrice(data.total_salary)}}</td>
                              <td>{{formatPrice(data.deduction)}}</td>
                              <td>{{formatPrice(data.total_salary - data.deduction)}}</td> -->

                          </tr>

                        </template>
                      </tbody>

                  </table>

                  <div v-else>
                    <loading></loading>
                  </div>
                </div>

              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

 
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import attendanceList from "./EmployeeAttendanceList";
import VueNotifications from "vue-notifications";
import { required, email } from "vuelidate/lib/validators";
import interfaces from "@/templates/_interfaces.js";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import globalTable from "@/templates/Table.vue";
import _accessApi from "@/router/_accessApi.js";

export default {
  name: "employee-attendance",
  components: { attendanceList, ModelSelect, loading, globalTable },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      listYear: [],
      listMonth: [],
      listData: [],
      listSourceCompanySalary: [],
      listDeduction: [],
      attendanceForm: interfaces.employee_attendance,
      loadingSubmit: false,
      loadingGetList: false,
      loading: false,
      day_in_month: 0,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      currentDivision: null,
      currentPosition: null,
      currentStatus: null,
      
      myDraft: [],

      flagValue: null,
      imgpath:
        location.host === "localhost:8080"
          ? _accessApi.localhost.upload_path
          : _accessApi.server.upload_path,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations() {
    if (this.flagValue !== "-") {
      return {
        attendanceForm: {
          employee_id: { required },
          attendance_date: { required },
          attendance_status: { required },
          notes: { required },
          file: { required },
        },
      };
    } else {
      return {
        attendanceForm: {
          employee_id: { required },
          attendance_date: { required },
          attendance_status: { required },
          notes: { required },
          file: {  },
        },
      };
    }
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.getDropdownAttendance();
      this.getListingAttendance();
    },
    OnFileSelected: function (event) {
      this.attendanceForm.file = event.target.files[0];
    },
    getListingAttendance: function () {
      this.loading = true;
      let data = {
        month: this.currentMonth,
        year: this.currentYear
      };

      //+'/'+this.currentYearthis.currentMonth+'/'+this.currentYear
      this.axios
        .post("web/employee/salary", data)
        .then((response) => {
          this.listData = response.data.data;
          this.listSourceCompanySalary = response.data.company_source_salary;
          this.listDeduction = response.data.deduction_list;

        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdownAttendance: function () {
      this.axios
        .get("web/dropdown/dropdown-employee-attendance/")
        .then((response) => {
          this.listEmployee = response.data.employee;
          this.listAttendanceStatus = response.data.attendance_status;
          this.listYear = response.data.year;
          this.listMonth = response.data.month;
          this.listEmployeeDivision = response.data.employee_division;
          this.listEmployeeStatus = response.data.employee_status;
          this.tempEmployeePosition = response.data.employee_position;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {});
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>

.blue-col {
  background-color: #b4c3d3;
}

.red-col {
  background-color: #f18686;
}

.green-col {
  background-color: #a2f3a7;
}

.yellow-col {
  background-color: #f4f73f;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive table {
  width: 100%;
  border-collapse: collapse;
}

.table-responsive td,
.table-responsive th {
  white-space: nowrap; /* biar tidak turun */
}

table {
  table-layout: auto;
  word-wrap: break-word;
  word-break: break-word;
}



</style>
